module.exports = __webpack_public_path__ + "static/media/removeBackground.6bcfddb8.gif";